import { Grid } from '@material-ui/core';
import {
  DateRange,
  Description as DescriptionIcon,
  DriveEta,
  Euro as EuroIcon,
  Language as LanguageIcon,
  PlaylistAdd,
  Restore,
  Schedule,
  SchoolRounded as SchoolIcon,
  SettingsBackupRestore as SettingsBackupRestoreIcon,
  VerifiedUser as VerifiedUserIcon,
  WatchLater as WatchLaterIcon,
  CreditCard,
} from '@material-ui/icons';
import Home from '@material-ui/icons/Home';
import { createOffer, deleteAnnonce } from '@webapps/business';
import {
  Button,
  useAuth,
  useMutation,
  useToast,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import PermisIcon from 'components/Icons/PermisIcon';
import Modal from 'components/Modal';
import parse from 'html-react-parser';
import theme from 'pages/MyMap/theme';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { FormattedDate, FormattedMessage } from 'react-intl';

import EditAnnonce from './EditAnnonce';
import HourglassHalf from 'components/Icons/HourglassHalf';

const {
  colors: { background },
} = theme;

const DetailsAnnonce = ({ info = {}, refetch, close }) => {
  const { idUser } = useAuth();
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);

  const [editModal, setEditModal] = useState(false);
  const { addToast } = useToast();
  const [stepModal, setStepModal] = useState(1);

  const handleOpenEditModal = () => {
    setEditModal(true);
  };
  const handleCloseEditModal = () => {
    setEditModal(false);
  };

  const {
    isLoading: isLoadingDelete,
    isSuccess: isSuccessDelete,
    mutateAsync: mutateDeleteAnnonce,
  } = useMutation(deleteAnnonce);

  const handleDeleteAnnonce = async (id) => {
    await mutateDeleteAnnonce({
      id,
    });
  };

  const {
    error,
    isLoading: IsLoadingDuplicate,
    isSuccess: isSuccessDuplicate,
    mutateAsync: mutateDuplicateAnnonce,
  } = useMutation(createOffer);

  const handleDuplicateAnnonce = async (annonce) => {
    const data = {
      job: {
        ogr: annonce.job.ogr,
      },
      business: {
        id: idUser,
      },
      degreeLevel: {
        id: annonce.degreeLevel.id,
      },
      description: annonce.description,
      contractType: {
        id: annonce.contractType.id,
      },
      address: {
        label: annonce.address.label,
        cityCode: annonce.address.cityCode,
        city: annonce.address.city,
      },
      contractLength: annonce.contractLength,
      renewable: annonce.renewable,
      workArrangement: annonce.workArrangement,
      telework: annonce.telework,
      salary: annonce.salary,
      salaryMax: annonce.salaryMax,
      jobAdvantages: annonce.jobAdvantages,
      transport: annonce.transport,
      drivingLicence: annonce.drivingLicence,
      createdAt: new Date(),
      lastUpdateDate: '',
      publicationDate: new Date(),
      deadLine: annonce.deadLine,
      onlyVerfiedProfile: annonce.onlyVerfiedProfile,
      workedLangage: annonce.workedLangage
    }
    await mutateDuplicateAnnonce({
      data: {
        ...data,
      }
    });
  };


  useEffect(() => {
    if (error) {
      addToast({
        status: 'error',
        message: 'Erreur pour dupliquer une annonce',
      });
    }
    if (isSuccessDelete || isSuccessDuplicate) {
      addToast({
        status: 'success',
        message: 'Operation réussie',
      });
      refetch();
      close();
    }
  }, [isSuccessDelete, isSuccessDuplicate]);

  return (
    <div className={classes.container}>
      <div className={cx(classes.title, global.title)}><p style={{ margin: 0 }}>Informations pratiques :</p></div>
      <div className={classes.infoPratique}>
        <Grid container>
          <Grid item>
            <div className={classes.info}>
              <SchoolIcon color="primary" className={[global.infoIcon, classes.itemIcon]} />
              <div className={css({ fontWeight: 600 })}>
                <FormattedMessage id="levelStudy" /> :{' '}
              </div>
              <div className={css({ marginLeft: spacing(1) })}>
                {info?.degreeLevel?.label}
              </div>
            </div>
            <div className={classes.info}>
              <DescriptionIcon color="primary" className={[global.infoIcon, classes.itemIcon]} />
              <div className={css({ fontWeight: 600 })}>
                <FormattedMessage id="typeContrate" /> :{' '}
              </div>
              <div className={css({ marginLeft: spacing(1) })}>
                {info?.contractType?.label}
              </div>
            </div>
            <div className={classes.info}>
              <EuroIcon color="primary" className={[global.infoIcon, classes.itemIcon]} />
              <div className={css({ fontWeight: 600 })}>
                <FormattedMessage id="salaire" /> :{' '}
              </div>
              <div className={css({ marginLeft: spacing(1) })}>
                {info?.salary} €/mois
              </div>
            </div>
            <div className={classes.info}>
              <HourglassHalf className={cx(global.infoIcon, classes.itemIcon)} />
              <div className={css({ fontWeight: 600 })}>
                <FormattedMessage id="dureeContrat" /> :{' '}
              </div>
              <div className={css({ marginLeft: spacing(1) })}>
                {info?.contractLength} mois
              </div>
            </div>
            {info?.jobAdvantages.length < 0 &&
              <div
                className={css({
                  marginTop: spacing(2),
                  display: 'flex',
                  flexDirection: 'column'
                })}
              >
                <div
                  className={css({
                    display: 'flex',
                  })}
                >
                  <PlaylistAdd color="primary" className={[global.infoIcon, classes.itemIcon]} />
                  <div
                    className={css({ fontWeight: 600 })}
                  >
                    Avantages :{' '}
                  </div>
                </div>
                <div className={css({ marginTop: spacing(1) })}>
                  {info?.jobAdvantages?.map(({ label }, index) => (
                    <li key={index}>{label}</li>
                  ))}
                </div>
              </div>}
            <div className={classes.info}>
              <LanguageIcon color="primary" className={[global.infoIcon, classes.itemIcon]} />
              <div className={css({ fontWeight: 600 })}>
                <FormattedMessage id="Langue(s) requise(s)" /> :{' '}
              </div>
              <div className={css({ marginLeft: spacing(1) })}>
                {info.workedLangage && info.workedLangage.length > 0 ? <>
                  {info?.workedLangage.map(({ label }) => `${label} `)}
                </> : <>Pas de langue requise</>}
              </div>
            </div>
            <div className={classes.info}>
              <DriveEta color="primary" className={[global.infoIcon, classes.itemIcon]} />
              <div className={css({ fontWeight: 600 })}>
                Être véhiculé :{' '}
              </div>
              <div className={css({ marginLeft: spacing(1) })}>
                {info?.transport ? 'Oui' : 'Non'}
              </div>
            </div>
            <div className={classes.info}>
              <CreditCard color="primary" className={[global.infoIcon, classes.itemIcon]} />
              <div className={css({ fontWeight: 600 })}>
                Type de permis :{' '}
              </div>
              <div className={css({ marginLeft: spacing(1) })}>
                {info?.drivingLicence === 'non'
                  ? 'Aucun'
                  : info?.drivingLicence}
              </div>
            </div>
            <div className={classes.info}>
              <Home color="primary" className={[global.infoIcon, classes.itemIcon]} />
              <div className={css({ fontWeight: 600 })}>
                Présence :{' '}
              </div>
              <div className={css({ marginLeft: spacing(1) })}>
                {info?.telework}
              </div>
            </div>
            <div className={classes.info}>
              <DateRange color="primary" className={[global.infoIcon, classes.itemIcon]} />
              <div className={css({ fontWeight: 600 })}>
                Dépôt de candidature : &nbsp;{' '}
              </div>
              <div className={classes.itemText}>
                <FormattedDate
                  day="numeric"
                  month="numeric"
                  value={info.publicationDate}
                  year="numeric"
                />
                {' '}au{' '}
                <FormattedDate
                  day="numeric"
                  month="numeric"
                  value={info.deadLine}
                  year="numeric"
                />
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
      <div className={classes.textContainer}>
        <div className={cx(classes.title, global.title)}><p style={{ margin: 0 }}>Description :</p></div>
        <div className={css({ marginBottom: spacing(2) })}>
          {info?.description ? (
            <div className={classes.modifyLink}>{parse(info?.description)}</div>
          ) : (
            <div>Pas de description</div>
          )}
        </div>
      </div>
      <div className={css({ display: 'flex', justifyContent: 'start', marginBottom: spacing(1) })}>
        <Button
          className={classes.btn}
          color="primary"
          disableElevation
          onClick={handleOpenEditModal}
          variant="contained"
        >
          Editer
        </Button>
        <Button
          className={css({ marginRight: spacing(1) })}
          color="primary"
          disabled={IsLoadingDuplicate}
          disableElevation
          onClick={() => handleDuplicateAnnonce(info)}
          variant="outlined"
        >
          Dupliquer
        </Button>
        <Button
          color="secondary"
          disabled={isLoadingDelete}
          disableElevation
          onClick={() => handleDeleteAnnonce(info?.id)}
          variant="outlined"
          className={css({ backgroundColor: 'white', border: '1px solid' })}
        >
          Supprimer
        </Button>
      </div>
      <Modal
        nbStep={5}
        onCancel={handleCloseEditModal}
        open={editModal}
        step={stepModal}
        width={800}
        subTitle="Gérez votre annonce"
        title="Modifiez l'offre d'emploi"
      >
        <EditAnnonce
          offer={info}
          onChangeStepModal={setStepModal}
          onClose={handleCloseEditModal}
          refetchOffre={refetch}
        />
      </Modal>
    </div>
  );
};

const styles = ({ spacing }) => ({
  container: {
    borderRadius: 10,
    background,
  },
  itemIcon: {
    color: "#0060F9"
  },
  title: {
    borderTop: '1px solid #C0D9FF',
    marginTop: spacing(2.5),
    paddingTop: spacing(2.5),
    marginBottom: spacing(2.5),
    '& p': {
      borderLeft: '3px solid #0060F9',
      paddingLeft: spacing(1)
    },
  },
  mobilePaddingBottom: {
    '@media (max-width:768px)': { paddingBottom: '0 !important' }
  },
  mobilePaddingTop: {
    '@media (max-width:768px)': { paddingTop: '0 !important' }
  },
  textContainer: {
    '& > *': {
      textAlign: 'justify',
    },
  },
  info: {
    marginTop: spacing(2),
    display: 'flex',
    alignItems: 'center',
    color: '#152652',
  },
  infoPratique: {
    marginTop: spacing(1),
    marginBottom: spacing(2),
  },
  modifyLink: {
    color: '#152652',
    a: {
      textDecoration: 'none',
    },
  },
  btn: {
    marginRight: spacing(1),
  }
});

DetailsAnnonce.propTypes = {
  info: PropTypes.object,
  refetch: PropTypes.func,
  close: PropTypes.func,
};

export default DetailsAnnonce;
